/** Day-0 interest tags (client stub until a tags API ships). */
export const ONBOARDING_TAGS_STORAGE_KEY = 'fetmode.onboarding.tags';

export const ONBOARDING_TAG_OPTIONS = [
  'bondage',
  'domination',
  'submission',
  'voyeur',
  'exhibition',
  'fetish',
  'leather',
  'latex',
  'roleplay',
  'toys',
  'group',
  'private',
] as const;

export type OnboardingTagId = (typeof ONBOARDING_TAG_OPTIONS)[number];

export interface OnboardingTagsState {
  completed: boolean;
  tags: OnboardingTagId[];
}

export function loadOnboardingTags(): OnboardingTagsState {
  const raw = localStorage.getItem(ONBOARDING_TAGS_STORAGE_KEY);
  if (!raw) {
    return { completed: false, tags: [] };
  }
  try {
    const parsed = JSON.parse(raw) as Partial<OnboardingTagsState>;
    const tags = Array.isArray(parsed.tags)
      ? parsed.tags.filter((tag): tag is OnboardingTagId =>
          (ONBOARDING_TAG_OPTIONS as readonly string[]).includes(String(tag)),
        )
      : [];
    return {
      completed: Boolean(parsed.completed),
      tags,
    };
  } catch {
    return { completed: false, tags: [] };
  }
}

export function saveOnboardingTags(input: {
  tags: readonly OnboardingTagId[];
  completed: boolean;
}): void {
  const payload: OnboardingTagsState = {
    completed: input.completed,
    tags: [...input.tags],
  };
  localStorage.setItem(ONBOARDING_TAGS_STORAGE_KEY, JSON.stringify(payload));
}

export function hasCompletedOnboardingTags(): boolean {
  return loadOnboardingTags().completed;
}
